import {actionTypes} from '../const';
var initialState = {
    notificationState:false,
    notifyMessage:''
}
const notificationState = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.NOTIFICATION_SUCCESS:
            return Object.assign({}, state, {
                notificationState : action.notifyObj.showNotification,
                notifyMessage: action.notifyObj.notifyMessage
            });
        case actionTypes.ACTION_INPROCESS:
            return Object.assign({}, state, {
                actionInProcess : action.actionInProcess
            })
        default:
            return state;
    }
}
export default notificationState;